import Vue from 'vue'
import Vuex from 'vuex'
import knowledge from './modules/knowledge'
import faq from './modules/faq'
import checkLists from './modules/checkLists'
import main from './modules/main'
import user from './modules/user'
import people from './modules/people'
import questionnaire from './modules/questionnaire'
import {NOTIFICATION_DANGER, NOTIFICATION_WARNING} from "../constants/common";

Vue.use(Vuex);

//const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        appClass: '',
        navVisible: true,
        headerVisible: true,
        popupVisible: false,
        popupComponent: false,
        popupData: {},
        confirmAction: {
            action: '',
            payload: {}
        },
        headerNav: {
            active: 0,
            items: []
        },
        notifications: []

    },
    actions: {
        switchPopup ({commit}, value = true) {
            return new Promise((resolve) => {
                commit('setPopup', value);
                if (!value) {
                    commit('setPopupComponent', null);
                    commit('setPopupData', {});
                }
                    setTimeout(() => {
                        resolve()
                    }, 500)
            })
        },
        visibleNav({commit}, delta) {
            if (Math.abs(delta) > 4) {
                if (delta >= 0) {
                    commit('setNavVisible', true);
                } else {
                    commit('setNavVisible', false);
                }
            }
        },
        pushNotification({commit}, notification) {
            notification.id =`f${(~~(Math.random()*1e8)).toString(16)}`;
            commit('pushNotification', notification);
        },

        errorHandler({commit}, error) {

            console.log(error);
            if(error.message === 'Network Error') {
                this.dispatch('pushNotification', {type: NOTIFICATION_DANGER, text: "Ошибка сети", time: 10000})
            } else {

                switch (error.response.status) {
                    case 401:
                        window.location.href = "/login";
                        break;
                    case 422:
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_WARNING,
                            text: "Ошибка сервера",
                            time: 10000
                        });
                        break;
                    default:
                        this.dispatch('pushNotification', {
                            type: NOTIFICATION_DANGER,
                            text: "Ошибка сервера",
                            time: 10000
                        });
                        break;
                }
            }

        }
    },
    mutations: {
        setPopup (state, value) {
            state.popupVisible = value
        },
        setPopupComponent (state, component) {
            state.popupComponent = component;
        },
        setPopupData (state, data) {
            state.popupData = data;
        },
        setHeaderVisible (state, value) {
            state.headerVisible = value
        },
        setNavVisible(state, value) {
            state.navVisible = value;
        },
        setAppClass (state, appClass) {
            state.appClass = appClass;
        },
        setHeaderNavItems(state, items){
            state.headerNav.items = items
        },
        setHeaderNavActive(state, index){
            state.headerNav.active = index
        },
        setConfirmAction(state, action){
            state.confirmAction= action
        },
        pushNotification(state, notification) {
            state.notifications.push(notification)
        },
        deleteNotification(state, id) {
            state.notifications.splice(state.notifications.findIndex(x => x.id === id), 1)
        }

    },
    modules: {
        checkLists,
        knowledge,
        faq,
        main,
        user,
        questionnaire,
        people
    },
    getters : {
        popupVisible: state => {
            return state.popupVisible;
        },
        popupComponent: state => {
            return state.popupComponent;
        },
        getAppClass: state => {
            return state.appClass + (state.navVisible ? '' : ' hide-nav') + (state.headerVisible ? '' : ' hidden-header')
        }
    }
    //strict: debug,
    //plugins: debug ? [createLogger()] : []
})